export enum HotelSortingType {
    Default = -1,
    HotelName = 0,
    HotelRating = 1,
    Price = 2,
    UserFavorite = 3,
    SallPoints = 4
}
